import { ImageTemplate } from "../template";
import { ImageProps } from "..";
import Background1x from "./payment-info-complete-1x.jpg";
import Background2x from "./payment-info-complete-1x.jpg";

export const PaymentInfoCompleteImage = ({
  height,
  width,
  highResolution,
  ...props
}: ImageProps): JSX.Element => {
  return (
    <div style={{ height, width }}>
      <ImageTemplate
        {...props}
        imgSrc={highResolution ? Background1x : Background2x}
      />
    </div>
  );
};
